import { selectToolsConfig } from '@optools/store/configApiSlice';
import { useAppSelector } from '@optools/store/hooks';
import { isAuthorized, isStreamingViewOnly } from '@optools/utils/auth';

import { useOktaProfile } from './useOktaProfile';

export const useAccessCheck = () => {
  const { profile } = useOktaProfile();
  const tools = useAppSelector(selectToolsConfig);

  const checkGroupAccess = (groups: string[]) => isAuthorized(groups, profile.groups);
  const checkStreamingViewOnly = (groups: string[]) => isStreamingViewOnly(groups, profile.groups);

  const showAudit = checkGroupAccess(tools.audit.auth.groups);
  const showBtcTools = checkGroupAccess(tools.btcTools.auth.groups);
  const showEsni = checkGroupAccess(tools.esni.auth.groups);
  const showOverrides = checkGroupAccess(tools.overrides.auth.groups);
  const showIpOverride = checkGroupAccess(tools.ipOverride.auth.groups);
  const showMediaValidation = checkGroupAccess(tools.mediaValidation.auth.groups);
  const showMilestones = checkGroupAccess(tools.milestones.auth.groups);
  const showLogger = checkGroupAccess(tools.logger.auth.groups);
  const showPartnerStreamDelivery = checkGroupAccess(tools.partner.auth.groups);
  const showUserLookup = tools.userLookup.enabled && checkGroupAccess(tools.userLookup.auth.groups);
  const showQaTools = tools.qaTools.enabled && checkGroupAccess(tools.qaTools.auth.groups);

  return {
    checkGroupAccess,
    checkStreamingViewOnly,
    showAudit,
    showBtcTools,
    showEsni,
    showIpOverride,
    showLogger,
    showMediaValidation,
    showMilestones,
    showOverrides,
    showPartnerStreamDelivery,
    showQaTools,
    showUserLookup,
  };
};
